import { Box, Flex, Text } from '@fundamentals'
import Image from 'next/image'
import React, { useState } from 'react'
import { Grid, Menu, MenuItem } from '@mui/material'
import { useRouter } from 'next/router'
import { useGetProfile } from '@core/react-query/features/profile/hooks/useGetProfile'
import { UserAvatar } from '@common/UserAvatar'
import { localizedStrings } from '@core/strings'
import { Logout } from '@mui/icons-material'
import { useIntercom } from 'react-use-intercom'

type UnauthenticatedPageLayoutProps = {
  page: React.ReactElement
}

export const PartiallyLoggedInLayout: React.FC<
  UnauthenticatedPageLayoutProps
> = ({ page }) => {
  const router = useRouter()
  const { shutdown } = useIntercom()
  const { data: profile } = useGetProfile()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleLogout = () => {
    API.logout()
    shutdown()
    setAnchorEl(null)
  }

  if (!router.isReady) {
    return null
  }

  return (
    <Flex
      mt={2}
      flexDirection={'column'}
      justifyContent='center'
      alignItems='center'
      position='relative'
    >
      {profile?.selfRegistered && (
        <Flex
          alignItems='center'
          gap={1}
          position='absolute'
          top={0}
          right={16}
        >
          <Box textAlign='right'>
            <Text fontSize={14} fontWeight={600}>
              {profile.firstName} {profile.lastName}
            </Text>
            <Text fontSize={12} color='text.secondary'>
              {profile.email}
            </Text>
          </Box>
          <UserAvatar
            user={profile}
            onClick={(event: React.MouseEvent<HTMLElement>) =>
              setAnchorEl(event.currentTarget as HTMLElement)
            }
          />
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            sx={{
              '& .MuiMenu-list': {
                py: 0.5,
              },
            }}
          >
            <MenuItem onClick={handleLogout} sx={{ fontSize: '13px' }}>
              <Logout fontSize='small' color='action' sx={{ mr: 1 }} />
              {localizedStrings.logout}
            </MenuItem>
          </Menu>
        </Flex>
      )}
      <Box mt={2} mb={4}>
        <Image
          width={240}
          height={37}
          className='logo'
          alt='Logo'
          src={'/images/logo/logo-dark-wordmark.svg'}
        />
      </Box>
      <Grid
        container
        spacing={2}
        justifyContent='center'
        alignItems='center'
        maxWidth={'700px'}
      >
        <Grid item xs={11}>
          {page}
        </Grid>
      </Grid>
    </Flex>
  )
}
